import store from '../store'
import {CommonApi} from '../request/common_api'

function paymentStatusSorts () {
  // 缴费处理状态
  if (store.state.payment.paymentStatusSorts.length) {
    return
  }
  CommonApi.getTableList('CHARGEPROCSTU').then(res => {
    if (res.retCode === '0000') {
      store.commit('payment/setPaymentStatusSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function paymentInfoStatusSorts () {
  // 缴费项目状态
  if (store.state.payment.paymentInfoStatusSorts.length) {
    return
  }
  CommonApi.getTableList('CHARGEITEMSTU').then(res => {
    if (res.retCode === '0000') {
      store.commit('payment/setPaymentInfoStatusSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

const getPaymentDropDownList = {paymentStatusSorts, paymentInfoStatusSorts}

export {getPaymentDropDownList}



// WEBPACK FOOTER //
// ./src/util/PaymentDropDownList.js